<template>
  <section class="Fiche__cartouche text-moyen">
    <div class="bigblock">
      <div class="block">
        <p>
          <span class="text-light">Programme</span>&nbsp;<span
            class="text-reg"
            >{{ p.program_description | mo }}</span
          >

          <span v-if="drop.indexOf('procedures') === -1">
            <span class="text-light"> Procédure</span>&nbsp;<span
              class="text-reg"
              >{{ mapNames(p.procedures) }}</span
            >
          </span>

          <span v-if="getEntrBySlug('maitre-douvrage', p.interlocuteurs_d)">
            <span class="text-light"> Maître&nbsp;d'ouvrage</span>&nbsp;<span
              class="text-reg"
              >{{
                getEntrBySlug("maitre-douvrage", p.interlocuteurs_d).partner
                  .name | u
              }}</span
            ></span
          >

          <span class="text-light" v-if="architectes">
            Équipe&nbsp;de&nbsp;maîtrise&nbsp;d'œuvre</span
          >&nbsp;<span class="text-reg"
            ><span v-for="(a, index) in architectes" :key="index"
              >{{ filterScalene(a) | u
              }}<span v-if="index !== architectes.length - 1">, </span></span
            ></span
          >

          <span v-if="drop.indexOf('missions') === -1 && p.missions.length > 0"
            ><span class="text-light">
              {{ "Mission" | plural(p.missions) }}</span
            >&nbsp;<span class="text-reg">{{ mapNames(p.missions) }}</span>
          </span>

          <span v-if="p.normes.length"
            ><span class="text-light"> Normes </span>&nbsp;<span
              class="text-reg"
              >{{ mapNames(p.normes) }}</span
            ></span
          >
          <span v-if="p.awards.length"
            ><span class="text-light"> Récompenses&nbsp;</span
            ><span class="text-reg"> {{ mapNames(p.awards) }}</span></span
          ><span v-if="p.cost"
            ><span class="text-light"> Coût</span>&nbsp;<span class="text-reg"
              >{{ formatNumbersFrench(p.cost) }}€</span
            ></span
          >
          <span v-if="p.surface"
            ><span class="text-light"> Surface</span>&nbsp;<span
              class="text-reg"
              >{{ formatNumbersFrench(p.surface) }}m<sup>2</sup></span
            ></span
          >
          <span v-if="p.surface"
            ><span class="text-light"> Typologies</span>&nbsp;<span
              class="text-reg"
              >{{ mapNames(p.typologies) }}</span
            ></span
          >
          <span v-if="p.labels.length">
            <span class="text-light"> Labels </span>&nbsp;<span
              class="text-reg"
              >{{ mapNames(p.labels) }}</span
            ></span
          >
        </p>
      </div>
      <div class="block">
        <p>
          <span class="text-reg">{{ text | mo }}</span>
        </p>
      </div>
    </div>
    <div class="bigblock">
      <div class="block" v-for="(column, i) in otherTexts" :key="i">
        <p
          v-for="(text, j) in column.filter(t => t.text)"
          :key="j"
          style="margin-bottom: 2.71mm;"
        >
          <span class="text-light">{{ text.name }}</span
          >&nbsp;<span class="text-reg">{{ text.text | mo }}</span>
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import {
  getEntrBySlug,
  getEntrNamesBySlugMatching,
  getArchitectesWithMandataireDistinction,
  mapNames,
  filterScalene,
  formatNumbersFrench
} from "../../../../../util/func";

export default {
  name: "CartoucheFiche",
  props: {
    p: {},
    pm: {},
    drop: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getEntrBySlug,
    getEntrNamesBySlugMatching,
    mapNames,
    filterScalene,
    formatNumbersFrench
  },
  computed: {
    architectes() {
      return getArchitectesWithMandataireDistinction(this.p);
    },
    text() {
      const a = this.p.contents_d.find(a => a.axe_id === 1);
      return a ? a.text : "";
    },
    otherTexts() {
      const p = this.p.contents_d.filter(a => a.axe_id !== 1 && a.text);
      const out = [[], []];
      let index = 0;
      while (p.length > 0) {
        out[index % 2].push(p.shift());
        index += 1;
      }
      return out;
    }
  }
};
</script>
